<template>
  <v-col class="error-message" cols="12" md="12">
    <span v-if="error">
      {{ $t('vehicle.licenseOrVinRequired') }}
    </span>
  </v-col>
</template>

<script>
export default {
  props: {
    error: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
.error-message {
  min-height: 24px;
  color: red;
  font-size: 14px;
  margin-top: 4px;
}
</style>
